import React from "react";
import { Link, useI18next } from "gatsby-plugin-react-i18next";
import LogoSvg from "src/images/logo/logo-image.svg";
import { setIsMenuOpen } from "./side-menu/side-menu-store";
const Logo = () => {
  const { navigate } = useI18next();

  return (
    <Link 
      to='/' 
      onClick={() => {
        setIsMenuOpen(false)
        navigate('/')
      }}
    >
      <img src={LogoSvg} alt='IFAB' className='h-8' />
    </Link>
  );
};

export default Logo;
